export default function registerLoadingDir($, apower) {

  $.registerDirective('loading', {

    loadingEl: null,

    update (value) {
      if (value) {
        this.loadingEl = this.loadingEl || $('<div class="loading"><div><div></div></div></div>')

        //很容易出现清空内部元素的情况, 例如 route
        this.loadingEl.appendTo(this.el)

        if (this.el.css('position') === 'static') {
          this.el.css('position', 'relative')
        }

        $.nextTick(() => {
          if (this.el.height() < 80) {
            this.loadingEl.addClass('loading-small')
            this.el.css('font-size', '0')
          }
        })
      }
      else if (this.loadingEl) {
        this.loadingEl.fadeOut(200, () => {
          this.loadingEl.hide()
        })

        this.el.css('font-size', '')
      }
    },
  })
}